import Emitter, {genEvent} from '../../services/emitter';

class MediaWindowServices {
    constructor() {
        this.config = {};
        this.onInit(() => {
            window.mediaWindow.ctx.registBeforeOpenHandler(this.config.onBeforeOpen);
            window.mediaWindow.ctx.registBeforeCloseHandler(this.config.onBeforeClose);
        });
    }

    setConfig (config) {
        this.config = config;
        if (config.onOpen) {
            this.onOpen(config.onOpen);
        }
        if (config.onClose) {
            this.onClose(config.onClose);
        }
    }

    onInit(handler, isOnce) {
        return genEvent('MediaWindowInit')(handler, isOnce);
    }

    onOpen(handler, isOnce) {
        return genEvent('MediaWindowOpen')(handler, isOnce);
    }

    onClose(handler, isOnce) {
        return genEvent('MediaWindowClose')(handler, isOnce);
    }

    open () {
        Emitter.emit('OpenMediaWindow');
    }
    close () {
        Emitter.emit('CloseMediaWindow');
    }
}

export default MediaWindowServices;